(function (m, $) {

    m.init = function () {
        var resizeTimeout;
        $(window).on("resize", function () {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(m.resizeWindow, 500);
        });

        m.resizeWindow();
    };

    m.resizeWindow = function() {
        var win = $(window);

        var ingredientsContainer = $(".ux-ingredients-container");
        var directionsContainer = $(".ux-directions-container");
        var ingredientsContent = $(".ux-ingredients");
        var directionsContent = $(".ux-directions");

        if (win.width() < ooooby.deviceSizeSmall) {
            ingredientsContent.appendTo(ingredientsContainer);
            directionsContent.appendTo(directionsContainer);
        }
        else if (win.width() >= ooooby.deviceSizeSmall) {
            ingredientsContent.appendTo(directionsContainer);
            directionsContent.appendTo(ingredientsContainer);
        }
    };

}(window.ooooby = window.ooooby || {}, jQuery));

$(document).ready(function () {
    ooooby.init();
});